module.exports = __webpack_public_path__ + "static/img/move2.b00539c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/connect/move2.png
// module id = vYbV
// module chunks = 7